import React from 'react'
import { ReadOnlyCustomField } from 'components/CustomFields/CustomFieldsColumn/CustomFieldsDetailsColumn/ReadOnlyCustomField'
import { useCustomFields } from 'context/customFields'

export function CustomFieldsDetailsColumn ({ section }) {
  const { customFields, entityId } = useCustomFields()

  return (
    <>
      {customFields && customFields[section.value]?.map(fieldDefinition =>
        <ReadOnlyCustomField
          key={fieldDefinition.id}
          entityId={entityId}
          definition={fieldDefinition}/>
      )}
    </>
  )
}